const getCompanyLogos = (company) => {
  return `https://firebasestorage.googleapis.com/v0/b/destino-ferias-dev.appspot.com/o/airlines%2F${company.toLowerCase()}.png?alt=media`;
};

export default getCompanyLogos;
